import React from "react";
import { RadioGroup } from "@telia/teddy";
import TEXT from "../../../text-consts";
import "./CustomerInfoForm.less";

interface Props {
    checked: boolean;
    setValue: (value: boolean) => void;
    disableLegal?: boolean;
}

const ProductUserController = ({ setValue, checked, disableLegal }: Props) => {
    return (
        <RadioGroup
            value={disableLegal ? "noen-andre" : checked ? "meg-selv" : "noen-andre"}
            onValueChange={(value) => {
                const isSomeoneElse = value === "noen-andre";
                setValue(isSomeoneElse);
            }}
        >
            <RadioGroup.GroupLabel>{TEXT.ADD_MEMBER.RADIO_GROUP.LABEL}</RadioGroup.GroupLabel>
            <div className="radio-group">
                <RadioGroup.Item>
                    <RadioGroup.Trigger value="meg-selv" disabled={disableLegal} />
                    <RadioGroup.Label>{TEXT.ADD_MEMBER.RADIO_GROUP.MEG_SELV}</RadioGroup.Label>
                </RadioGroup.Item>
                <RadioGroup.Item>
                    <RadioGroup.Trigger value="noen-andre" />
                    <RadioGroup.Label>{TEXT.ADD_MEMBER.RADIO_GROUP.NOEN_ANDRE}</RadioGroup.Label>
                </RadioGroup.Item>
            </div>
        </RadioGroup>
    );
};

export default ProductUserController;
